import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ClientTools" }

import AcumulusClientCreate from "@/components/pages/client/AcumulusClientCreate.vue";
import InnButton from "@/components/ds/button/Button.vue";
import IconButton from "@/components/ds/icon-button/IconButton.vue";
import { computed, PropType } from "vue";
import { Client } from "@/types";
import api from "@/api";
import { useRouter } from "vue-router";
import { useUiStore } from "@/stores/ui";
import { useClientStore } from "@/stores/clients";
import Tools from "@/components/general/tools/Tools.vue";
import Tool from "@/components/general/tools/Tool.vue";
import { useCompanyStore } from "@/stores/company";
import Panel from "@/components/general/Panel.vue";
import ClientProjects from "@/components/pages/client/ClientProjects.vue";
import InnSection from "@/components/general/Section.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientTools',
  props: {
    client: {
        type: Object as PropType<Client>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const router = useRouter();
const uiStore = useUiStore();
const clientsStore = useClientStore();
const companyStore = useCompanyStore();

const deleteClient = () => {
    if (props.client) {
        api.delete(props.client, "clients").then(() => {
            if (props.client) {
                clientsStore.delete(props.client);
            }
            router.push({ name: "Clients" });
            uiStore.message("Klant verwijderd...");
        });
    }
};

const url = computed(() => {
    const id = props.client.acumulus_client_id;
    return (
        "https://www.sielsystems.nl/acumulus/e_relatie.php?relatie_ID=" +
        id +
        "&from=l_relaties&pos_y=0"
    );
});

const openClientInAcumulus = () => {
    window.open(url.value);
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Tools, null, {
      default: _withCtx(() => [
        (_unref(companyStore).company?.usesAcumulus)
          ? (_openBlock(), _createBlock(Tool, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(AcumulusClientCreate, { client: __props.client }, null, 8, ["client"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (
                    _unref(companyStore).company?.usesAcumulus &&
                    _unref(companyStore).company.acumulus_client_id !== 0
                )
          ? (_openBlock(), _createBlock(Tool, { key: 1 }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _cache[0] || (_cache[0] = _createElementVNode("h4", null, "Link in Acumulus", -1)),
                  _createTextVNode(" " + _toDisplayString(url.value), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(Panel, { title: "Projecten" }, {
      default: _withCtx(() => [
        _createVNode(InnSection, null, {
          default: _withCtx(() => [
            _createVNode(ClientProjects, { client: __props.client }, null, 8, ["client"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(Panel, { title: "Tools" }, {
      default: _withCtx(() => [
        _createVNode(InnSection, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_dialog, { "max-width": "500" }, {
              activator: _withCtx(({ props: activatorProps }) => [
                _createVNode(IconButton, _mergeProps(activatorProps, {
                  "icon-id": "trash",
                  variant: "danger"
                }), {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode(" Verwijder klant ")
                  ])),
                  _: 2
                }, 1040)
              ]),
              default: _withCtx(({ isActive }) => [
                _createVNode(_component_v_card, { style: {"padding":"12px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode(" Wil je " + _toDisplayString(__props.client.name) + " verwijderen? ", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(InnButton, {
                          onClick: 
                                        () => {
                                            isActive.value = false;
                                            deleteClient();
                                        }
                                    
                        }, {
                          default: _withCtx(() => _cache[2] || (_cache[2] = [
                            _createTextVNode(" Verwijderen ")
                          ])),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})